import React from 'react'
import RecentActivityPage from './RecentActivity'

const RecentActivity = () => (
  <RecentActivityPage/>
)

export default RecentActivity
